export default "__VITE_ASSET__D$Qoj9UU__"